import { Component } from '@angular/core';
import { RippleFieldGenericComponent } from '../ripple-field-generic/ripple-field-generic.component';

@Component({
  selector: 'ripple-form-text-editor',
  templateUrl: './form-text-editor.component.html',
  styleUrls: ['./form-text-editor.component.scss']
})
export class FormTextEditorComponent extends RippleFieldGenericComponent { }
